import { Box, Button, Card, CardProps, Link, Typography, useModal } from "@xcorejs/ui";
import { HappyHoursModal } from "components/HappyHours";
import Richtext from "design-system/Richtext";
import { Heading3 } from "design-system";
import { EventValues } from "xcore/types";

type EventRegistrationCardProps = {
  eventValues: EventValues;
  when: string;
  where: string;
  register: string;
  showOnMap: string;
} & CardProps;

const EventRegistrationCard = ({
  eventValues: { day, month, year, hours, minutes, mapLink, latitude, longitude, address, registrationModal },
  when,
  where,
  register,
  showOnMap,
}: EventRegistrationCardProps) => {
  const [open] = useModal(HappyHoursModal, { content: registrationModal });

  return (
    <Card
      variant="outline"
      padding="2rem"
      body={
        <Box width="100%">
          <Heading3 mb="1rem">{when}</Heading3>
          <Typography fontSize="42px" lineHeight="57px" color="black">
            {day}. {month}. {year} <span style={{ color: "lightGray" }}>/</span> {hours}:{minutes}
          </Typography>
          <Heading3 mt="2rem" mb="1rem">
            {where}
          </Heading3>
          <Richtext value={address} />
          <Typography mb="3rem">
            {parseFloat(longitude!).toFixed(6)} {parseFloat(latitude!).toFixed(6)} /{" "}
            {mapLink && mapLink !== "" && (
              <Link variant="underline" as="a" href={mapLink}>
                {showOnMap}
              </Link>
            )}
          </Typography>
          <Button onClick={() => open({})}>{register}</Button>
        </Box>
      }
      boxShadow="none"
      width="100%"
      minWidth="100%"
    />
  );
};

export default EventRegistrationCard;
